import React from 'react';
import { Form, Input, Select, Switch } from 'antd';

const { Option } = Select;

const DatasetNodeProperties = ({ config, nodeType }) => {
  return (
    <>
      <Form.Item label="Filename" name="filename" initialValue={config.filename}>
        <Input placeholder="Enter filename" />
      </Form.Item>
      <Form.Item label="Format" name="format" initialValue={config.format || 'csv'}>
        <Select>
          <Option value="csv">CSV</Option>
          <Option value="json">JSON</Option>
          <Option value="excel">Excel</Option>
        </Select>
      </Form.Item>
      {nodeType === 'csv_import' && (
        <>
          <Form.Item label="Delimiter" name="delimiter" initialValue={config.delimiter || ','}>
            <Input placeholder="," />
          </Form.Item>
          <Form.Item label="Has Header" name="hasHeader" initialValue={config.hasHeader !== false} valuePropName="checked">
            <Switch />
          </Form.Item>
        </>
      )}
    </>
  );
};

export default DatasetNodeProperties;